<template>
  <div>
    <div v-show="page1">
      <img class="bg" src="../assets/01/layout/layout-1.jpg" />
      <div style="position:absolute;left:35.4vw;top:87.5vw;">
        <input
          style="top:0vw;"
          :checked="this.answer[0] == 1"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(0, 1)"
        />
        <input
          style="top:4vw;"
          :checked="this.answer[0] == 2"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(0, 2)"
        />
        <input
          style="top:8vw;"
          :checked="this.answer[0] == 3"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(0, 3)"
        />
        <input
          style="top:12vw;"
          :checked="this.answer[0] == 4"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(0, 4)"
        />
      </div>
      <div style="position:absolute;left:35.4vw;top:114.5vw;">
        <input
          style="top:0vw;"
          :checked="this.answer[1] == 1"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(1, 1)"
        />
        <input
          style="top:4vw;"
          :checked="this.answer[1] == 2"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(1, 2)"
        />
        <input
          style="top:8vw;"
          :checked="this.answer[1] == 3"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(1, 3)"
        />
        <input
          style="top:12vw;"
          :checked="this.answer[1] == 4"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(1, 4)"
        />
      </div>
      <div style="position:absolute;left:35.4vw;top:141.5vw;">
        <input
          style="top:0vw;"
          :checked="this.answer[2] == 1"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(2, 1)"
        />
        <input
          style="top:4vw;"
          :checked="this.answer[2] == 2"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(2, 2)"
        />
        <input
          style="top:8vw;"
          :checked="this.answer[2] == 3"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(2, 3)"
        />
        <input
          style="top:12vw;"
          :checked="this.answer[2] == 4"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(2, 4)"
        />
      </div>
      <div style="position:absolute;left:35.4vw;top:168.5vw;">
        <input
          style="top:0vw;"
          :checked="this.answer[3] == 1"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(3, 1)"
        />
        <input
          style="top:4vw;"
          :checked="this.answer[3] == 2"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(3, 2)"
        />
        <input
          style="top:8vw;"
          :checked="this.answer[3] == 3"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(3, 3)"
        />
        <input
          style="top:12vw;"
          :checked="this.answer[3] == 4"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(3, 4)"
        />
      </div>
      <div style="position:absolute;left:35.4vw;top:195.5vw;">
        <input
          style="top:0vw;"
          :checked="this.answer[4] == 1"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(4, 1)"
        />
        <input
          style="top:4vw;"
          :checked="this.answer[4] == 2"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(4, 2)"
        />
        <input
          style="top:8vw;"
          :checked="this.answer[4] == 3"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(4, 3)"
        />
        <input
          style="top:12vw;"
          :checked="this.answer[4] == 4"
          class="checkbox"
          type="checkbox"
          @click="SelectAnswer(4, 4)"
        />
      </div>
      <img
        v-show="
          !(
            answer[0] != -1 &&
            answer[1] != -1 &&
            answer[2] != -1 &&
            answer[3] != -1 &&
            answer[4] != -1
          )
        "
        style="position:absolute;left:40vw;top:227vw;width:20vw;"
        src="../assets/01/content/content-增2.png"
      />
      <map
        v-show="
          answer[0] != -1 &&
            answer[1] != -1 &&
            answer[2] != -1 &&
            answer[3] != -1 &&
            answer[4] != -1
        "
        style="position:absolute;left:43vw;top:231vw;width:14vw;height:5vw;background:transparent;"
        @click="OnSend"
      />
    </div>
    <div v-show="page2">
      <img class="bg" src="../assets/01/Background/background.png" />
      <img
        style="position:absolute;left:12vw;top:56vw;width:76vw;"
        src="../assets/01/content/content-06.png"
      />
      <div
        class="hrgrid"
        :style="
          `position:absolute;left:5vw;top:73vw;grid-template-rows: repeat(3, auto);`
        "
      >
        <div
          class="hrgrid"
          :style="`grid-template-rows: repeat(${hrcount}, 1fr);`"
        >
          <img
            v-show="hrresult1 != null"
            style="position:relative;left:0vw;top:0vw;width:90vw;"
            :src="hrresult1"
          />
          <img
            v-show="hrresult2 != null"
            style="position:relative;left:0vw;top:0vw;width:90vw;"
            :src="hrresult2"
          />
        </div>
        <div style="padding-top:10vw;padding-bottom:3vw;">
          <img style="width:20vw;" src="../assets/01/content/content-07.png" />
        </div>
        <div
          class="vtgrid"
          :style="`grid-template-columns: repeat(${clcount}, 1fr);`"
        >
          <img
            v-show="vrresult1 != null"
            style="width:30vw;"
            :src="vrresult1"
          />
          <img
            v-show="vrresult2 != null"
            style="width:30vw;"
            :src="vrresult2"
          />
          <img
            v-show="vrresult3 != null"
            style="width:30vw;"
            :src="vrresult3"
          />
        </div>
        <div style="padding-top:3vw;">
          <img
            style="width:15vw;"
            src="../assets/01/icon/icon-02.png"
            @click="OnShowPage1"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page1: true,
      page2: false,
      answer: [-1, -1, -1, -1, -1],
      hrcount: 1,
      clcount: 2,
      hrresult1: null,
      hrresult2: null,
      vrresult1: null,
      vrresult2: null,
      vrresult3: null,
    };
  },
  mounted() {},
  methods: {
    SelectAnswer(index, ans) {
      if (this.answer[index] == ans) {
        this.answer[index] = -1;
      } else {
        this.answer[index] = ans;
      }
      this.$forceUpdate();
    },
    OnShowPage1() {
      window.scrollTo(0, 0);
      this.answer = [-1, -1, -1, -1, -1];
      this.page1 = true;
      this.page2 = false;
    },
    OnSend() {
      var ansCount = [];
      for (var i = 0; i < this.answer.length; i++) {
        if (ansCount[this.answer[i]] == undefined) {
          ansCount[this.answer[i]] = 1;
        } else {
          ansCount[this.answer[i]]++;
        }
      }

      this.hrresult1 = null;
      this.hrresult2 = null;
      var hitems = [];
      for (var j = 1; j <= 4; j++) {
        if (ansCount[j] != undefined) {
          if (ansCount[j] >= 4) {
            this.hrcount = 1;
            this.hrresult1 = require(`../assets/01/content/result-${j}H.png`);
            this.hrresult2 = null;
            hitems.push(j);
          } else if (ansCount[j] >= 2) {
            if (this.hrresult1 == null) {
              this.hrcount = 1;
              this.hrresult1 = require(`../assets/01/content/result-${j}H.png`);
              hitems.push(j);
            } else {
              this.hrcount = 2;
              this.hrresult2 = require(`../assets/01/content/result-${j}H.png`);
              hitems.push(j);
            }
          }
        }
      }
      this.vrresult1 = null;
      this.vrresult2 = null;
      this.vrresult3 = null;
      this.clcount = 1;
      console.log(hitems);
      for (var k = 1; k <= 4; k++) {
        if (!hitems.includes(k)) {
          if (this.vrresult1 == null) {
            this.vrresult1 = require(`../assets/01/content/result-${k}V.png`);
          } else if (this.vrresult2 == null) {
            this.vrresult2 = require(`../assets/01/content/result-${k}V.png`);
            this.clcount = 2;
          } else if (this.vrresult3 == null) {
            this.vrresult3 = require(`../assets/01/content/result-${k}V.png`);
            this.clcount = 3;
          }
        }
      }
      this.page1 = false;
      window.scrollTo(0, 0);
      this.page2 = true;
    },
  },
};
</script>
<style scoped>
.bg {
  position: absolute;
  top: 0;
  left: 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100vw;
  max-width: 100vw;
}
.checkbox {
  position: absolute;
  width: 1.2vw;
  height: 1.2vw;
  z-index: 2;
}
.hrgrid {
  height: auto;
  width: 90vw;
  display: grid;
  justify-items: center;
}
.vtgrid {
  height: auto;
  width: auto;
  display: grid;
  justify-items: center;
}
</style>
